<template>
  <div class="modal tw-bg-[#00000080] tw-flex">
    <div
      class="
        tw-bg-white
        md:tw-mx-auto md:tw-max-w-md
        tw-w-full tw-h-min tw-my-auto
      "
    >
      <h3 class="tw-font-semibold tw-mt-8 tw-px-6 tw-text-xl">
        {{ isEditTag ? "Editar etiqueta" : "Nova etiqueta" }}
      </h3>
      <div class="tw-flex tw-flex-col tw-gap-4 tw-px-8 tw-py-6">
        <div class="tw-flex tw-gap-x-4">
          <div>
            <label :class="this.tagInputs.errorColor ? 'tw-text-red-600' : ''">Cor*</label>
            <div class="dropdown tw-flex admin-form">
              <button
                :class="
                  ' select btn tw-w-16 tw-px-2 !tw-border !tw-border-gray-400 !tw-h-[unset] tw-border-solid '
                  + tagInputs.hasColor
                "
                data-toggle="dropdown"
              >
                <div
                  :style="{ backgroundColor: currentTag.color }"
                  class="tw-w-5 tw-h-5 tw-rounded-full"
                ></div>
                <i class="arrow tw--translate-y-1/2 tw-right-0 tw-top-1/2"></i>
              </button>
              <div class="dropdown-menu tw-min-w-0">
                <div
                  class="
                    tw-flex
                    tw-justify-center
                    tw-gap-2
                    tw-py-1
                    tw-w-36
                    tw-flex-wrap
                  "
                >
                  <div v-for="(color, index) in colors" :key="index">
                    <label
                      :for="color.color"
                      :style="{ backgroundColor: color.color }"
                      class="tw-w-5 tw-h-5 tw-rounded-full tw-cursor-pointer"
                    ></label>
                    <input
                      type="radio"
                      v-model="currentTag.color"
                      :value="color.color"
                      :id="color.color"
                      class="tw-hidden"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tw-flex-1">
            <label :class="this.tagInputs.errorName ? 'tw-text-red-600' : ''">Nome da etiqueta*</label>
            <input
              v-model="currentTag.name"
              placeholder=""
              maxlength="36"
              :class="'form-control tw-w-full tw-rounded ' + tagInputs.hasName"
            />
          </div>
        </div>
        <span v-if="hasError" class="tw-block tw-text-red-600">
          {{ this.errorMessage }}
        </span>
        <div class="tw-flex tw-justify-between">
          <button @click="closeHandleTag" type="button" class="btn tw-pl-0">
            Cancelar
          </button>
          <button
            :disabled="isLoading"
            @click="handleTagInputs"
            type="button"
            class="btn btn-blue"
          >
            {{ isLoading ? "Salvando" : "Salvar" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const COLORS = [
  { color: "#4E5BA6", name: "gray" },
  { color: "#101323", name: "black" },
  { color: "#004EEB", name: "blue" },
  { color: "#099250", name: "green" },
  { color: "#86CB3C", name: "lime" },
  { color: "#BA24D5", name: "violet" },
  { color: "#C01048", name: "red" },
  { color: "#FF4405", name: "orange" },
  { color: "#FD6F8E", name: "pink" },
  { color: "#FAC415", name: "yellow" },
];
export default {
  props: [
    "handleTagInputs",
    "isEditTag",
    "closeHandleTag",
    "currentTag",
    "tagInputs",
    "isLoading",
    "hasError",
  ],
  data() {
    return {
      colors: COLORS,
    };
  },
  computed: {
    errorMessage() {
      if (this.isEditTag) {
        return "Houve um erro ao editar a etiqueta, tente novamente.";
      }
      return "Houve um erro ao criar a etiqueta, tente novamente.";
    },
  },

};
</script>
